// 📁 FICHIER : src/config/constants.ts
// 📝 Constantes de l'application

// Définir UserRole localement au lieu de l'importer
type UserRole = 
  | "super_admin" 
  | "admin_etablissement" 
  | "enseignant" 
  | "eleve" 
  | "parent";

// URL de base de l'API
export const API_BASE_URL = (process.env.REACT_APP_API_URL ?? "http://localhost:3000");

// Points de terminaison de l'API
// ⚠️ `classes` A ÉTÉ RETIRÉ : `/api/classes` n'a jamais existé côté serveur.
// Les classes ne sont pas une table — elles vivent dans `configurations.classes`
// et se lisent par `GET /api/config-simple/:etab?annee_scolaire=`. Laisser
// l'entrée ici invitait à rappeler une route fantôme : le cahier de texte le
// faisait, recevait un 404 en HTML, et l'application annonçait « le serveur est
// injoignable » alors qu'il répondait parfaitement (31/07).
export const API_ENDPOINTS = {
  etablissements: "/api/etablissements",
  eleves: "/api/eleves",
  admins: "/api/admins",
} as const;

// Labels des rôles utilisateurs
export const ROLE_LABELS: Record<UserRole, string> = {
  super_admin: "Super Administrateur 👑",
  admin_etablissement: "Administrateur Établissement 🏛️",
  enseignant: "Enseignant 📚",
  eleve: "Élève 🎓",
  parent: "Parent 👨‍👩‍👧",
};

// Années scolaires disponibles
export const ANNEES_SCOLAIRES = ["2024-2025", "2025-2026", "2026-2027", "2027-2028"];

// Export par défaut (optionnel)
export default {
  API_BASE_URL,
  API_ENDPOINTS,
  ROLE_LABELS,
  ANNEES_SCOLAIRES,
};